import React, {Fragment, useContext, useEffect, useState} from 'react';
import {v4 as uuidv4} from 'uuid';
import {Link} from "react-router-dom";
import farmerContext from "../../../context/farmer/farmerContext";
import EquipmentService_modal from "./EquipmentService_modal"

const EquipmentService = () => {

    const FarmerContext = useContext(farmerContext);
    let [rerender, setRerender] = useState(uuidv4())
    const {getEquipmentServices, farmer, clearPageLoading,} = FarmerContext;
    const {equipmentServices, page_loading} = farmer;
    // modal method
    let [equipmentService_modal, setEquipmentService_modal] = useState(
        [{
            image: "",
            name: "",
            manufacturer: ""

        }]
    )

    let [id, setID] = useState("")
    const modal_data = (equipmentService) => {
        setEquipmentService_modal(equipmentService.equipments)
        setID(equipmentService.id)
        setRerender(uuidv4())
    }

    //fetch equipment from server if it's not available locally
    useEffect(() => {

        if (equipmentServices.length === 0) {
            getEquipmentServices().then(res=>{
                clearPageLoading();
            });
        } else {
            clearPageLoading();
        }
        //eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <div className="row mt-3">
                <div className="col-lg-12">
                    <h4>Services</h4>
                    <hr/>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className={page_loading + " justify-content-center"}>
                                <div className="spinner-grow text-success" role="status"
                                     style={{width: "6rem", height: "6rem"}}>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {equipmentServices.length > 0 ? equipmentServices.map((equipmentService) => (


                            <div className="col-lg-3 mb-3" key={uuidv4()}>
                                <div className="card h-100">
                                    <div className="card-image-holder-idea-2">
                                        <img src={equipmentService.image}
                                             className="card-img-top w-100 h-100 obj-fit" alt="..."/>
                                    </div>
                                    <div className="card-body d-flex flex-column">
                                        <h5 className="card-title">{equipmentService.custom_name}</h5>
                                        <p className="card-text flex-grow-1">{equipmentService.terms_and_condition}</p>
                                        <h6>₦{Number(parseFloat(equipmentService.service_price)).toLocaleString()}</h6>
                                        <hr/>
                                        <div className="row">
                                            <div className="col-lg-6 mb-3">
                                                <button className="btn btn-sm btn-block btn-lemon-green" key={uuidv4()}
                                                        onClick={() => modal_data(equipmentService)}>Details
                                                </button>
                                            </div>
                                            <div className="col-lg-6 mb-3">
                                                <Link to={`/farmer/checkout/${equipmentService.id}`}
                                                      className="btn btn-sm btn-block btn-orange">Hire</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )) : <span>No data to display</span>
                        }

                    </div>
                    <EquipmentService_modal equipmentService_modal={equipmentService_modal} rerender={rerender}
                                            id={id}/>

                    <div className="col-lg-12 mb-3 text-center">
                        <div aria-label="Page navigation">
                            <ul className="pagination text-center">
                                <li className="page-item"><a className="page-link" href="#">Previous</a>
                                </li>
                                <li className="page-item"><a className="page-link" href="#">1</a></li>
                                <li className="page-item"><a className="page-link" href="#">2</a></li>
                                <li className="page-item"><a className="page-link" href="#">3</a></li>
                                <li className="page-item"><a className="page-link" href="#">Next</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

        </Fragment>
    )
}

export default EquipmentService